import { render } from "./TagIcon.vue?vue&type=template&id=3b68ec28"
import script from "./TagIcon.vue?vue&type=script&lang=js"
export * from "./TagIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__